import { render, staticRenderFns } from "./customer_company_card.vue?vue&type=template&id=b4a8fcce&scoped=true&"
import script from "./customer_company_card.vue?vue&type=script&lang=js&"
export * from "./customer_company_card.vue?vue&type=script&lang=js&"
import style0 from "./customer_company_card.vue?vue&type=style&index=0&id=b4a8fcce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a8fcce",
  null
  
)

export default component.exports